import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { StorageServiceObservablesService } from '../storage-service-observables/storage-service-observables.service';
import { BillingPaymentService } from '../my-insurance/billing-payment.service';
import { Observable, Subject, of } from 'rxjs';
import { UrlValidationService } from '@services/document/url-validation.service';
import { UserDataService } from '../data-services/user-data.service';
import { map, switchMap, take } from 'rxjs/operators';

export interface GuestPaymentInitResponse {
  sessionToken: string;
  paymentusToken: string;
  policyData: Map<string, any>;
  currentBills: any[];
  guestPaymentStatus: number;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentServiceService {
  public obj: any;

  paymentObject: any;
  isAcmic: boolean;
  private paymentUsToken: Promise<string>;
  private guestSessionToken: string;

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private storageService: StorageServiceObservablesService,
    private billingPaymentService: BillingPaymentService,
    private acmicService: AcmicService,
    private urlValidationService: UrlValidationService,
    private userDataService: UserDataService,
  ) { }

  hideModalOnRoute = new Subject<boolean>();

  setModalHide(value) {
    this.hideModalOnRoute.next(value);
  }

  getModalHide() {
    return this.hideModalOnRoute.asObservable();
  }

  detectStateCode() {
    return this.acmicService.isACMIC();
  }

  getType() {
    return this.detectStateCode() ? 'AAA_INSURANCE' : 'INSURANCE';
  }

  paymentUser(email, policyNumber) {
    void email;
    void policyNumber;
    return of("");
  }

  paymentGuest(policyNumber, zipcode) {
    const body = {
      emailId: null,
      loginId: null,
      sc: 'B2C Guest',
      type: this.getType(),
      step: 2,
    };

    const url = `${environment.backend_server_url_billing}/${zipcode}/${policyNumber}/paymentus-guest`;
    return this.http.post(url, body, { responseType: 'text' });
  }

  initiateGuestPayment(policyNumber: string, zipCode: string): Observable<GuestPaymentInitResponse> {
    const body = {
      policyNumber,
      zipCode,
      paymentDetails: {
        emailId: null,
        loginId: null,
        sc: 'B2C Guest',
        type: this.getType(),
        step: 2,
      },
    };
    const url = `${environment.backend_server_url_billing}/guest/initiate-payment`;
    return this.http.post<GuestPaymentInitResponse>(url, body);
  }

  setGuestSessionToken(token: string) {
    this.guestSessionToken = token;
  }

  getGuestSessionToken(): string {
    return this.guestSessionToken;
  }

  paymentWallet(email) {
    const body = {
      emailId: email,
      loginId: email,
      sc: 'B2C',
      type: this.getType(),
      step: null,
    };
    const url = `${environment.backend_server_url_billing}/${email}/account-setting`;
    // const url = `/b2c-billing/v1/${email}/account-setting`;
    console.log("payment Wallet : ", url)
    return this.http.post(url, body, { responseType: 'text' });
  }

  getPaymentusTronwebToken(paymentType: string, policyNumber: string): Observable<any> {
    const email = this.storageService.getUserFromStorage();
    return this.userDataService.$userData.pipe(
      take(1),
      map(user => ({
        firstName: user?.userDetails?.firstName ?? "",
        lastName: user?.userDetails?.lastName ?? "",
        email: email,
        paymentType: paymentType,
        policyNumber: policyNumber
      })),
      switchMap(body => {
          const url = `${environment.backend_server_url_billing}/paymentus-tw-token`;
        // const url = `/b2c-billing/v1/paymentus-tw-token`;
        return this.http.post(url, body, { responseType: 'text' });
      })
    )
  }

  getTWListProfiles(policyNumber: string): Observable<any> {
     const url = `${environment.backend_server_url_billing}/${policyNumber}/tw-listProfiles`;
    // const url = `/b2c-billing/v1/${policyNumber}/tw-listProfiles`;
     return this.http.get(url);
  }

  enrollInAutopayCCDC(policyNumber: string, cardType: string, token: string, paymentStatus?: string): Observable<any> {
    console.log("Enroll paymentStatus : ", paymentStatus)
    const email = this.storageService.getUserFromStorage();
    const body = {
      email: email,        
      policyNumber: policyNumber,
      paymentMethod: cardType,
      cardToken: token,
      paymentStatus: paymentStatus
    };
    const url = `${environment.backend_server_url_billing}/enroll-autopay-ccdc`;
    // const url = `/b2c-billing/v1/enroll-autopay-ccdc`;
    return this.http.post(url, body, { responseType: 'text' });
  }

  unenrollFromAutopayCCDC(policyNumber: string, email: string): Observable<any> {
    const body = {
      email: email,        
      policyNumber: policyNumber,
    };
    const url = `${environment.backend_server_url_billing}/unenroll-autopay-ccdc`;
    // const url = `/b2c-billing/v1/unenroll-autopay-ccdc`;
    return this.http.post(url, body, { responseType: 'text' });
  }

  setData(zipcode, policyNumber) {
    this.obj = {
      zipcode,
      policyNumber,
    };
  }

  getData() {
    return this.obj;
  }

  setPaymentData(policyNumber, zipCode, minAmount) {
    localStorage.removeItem('xP');
    localStorage.setItem(
      'xP',
      `${btoa(policyNumber)}|${btoa(zipCode)}|${btoa(minAmount)}`
    );
  }

  setWalletData(token) {
    localStorage.removeItem('wT');
    localStorage.setItem('wT', `${token}`);
  }

  getPaymentData() {
    return localStorage.getItem('xP');
  }

  getTokenData() {
    return localStorage.getItem('wT');
  }

  onPayByCard(policyNumber, zipCode, minAmount) {
    if (policyNumber.length === 10) {
      this.paymentUser(
        this.storageService.getUserFromStorage(),
        policyNumber
      ).subscribe(
        (token) => {
          this.paymentUsRedirection(token);
        },
        () => {
          this.alertService.error('Please try again later');
        }
      );
    } else {
      this.billingPaymentService.makePayment(policyNumber, zipCode, minAmount);
    }
    this.setModalHide(true);
  }

  paymentUsRedirection(token) {
    if (this.urlValidationService.isApprovedRedirectUrl(environment.paymentus_account)) {
      const newWindow = window.open(
        `${environment.paymentus_account}${token}&brand=${this.detectStateCode() ? 'AAA' : 'MAPFRE'
        }`,
        '_blank'
      );

      if (!newWindow) {
        alert('Please turn off the popup blocker');
      }
    }
  }
  clear() {
    this.obj = {
      zipCode: '',
      policyNumber: '',
    };
  }

  preloadAndSaveToken(policyNumber: string) {
    this.paymentUsToken = this.paymentUser(
      this.storageService.getUserFromStorage(),
      policyNumber
    ).toPromise();
  }

  redirectToPaymentExpress(isNativeApp: boolean, isAcmic: boolean) {
    this.paymentUsToken
      .then((token) => {
        const paymentUsURL = `${environment.paymentus_account}${token}&brand=${isAcmic ? 'AAA' : 'MAPFRE'
          }`;

        if (isNativeApp) {
          this.openInNewWindow(paymentUsURL);
        } else {
          const link = document.createElement('a');
          link.href = paymentUsURL;
          link.target = '_blank';
          link.click();
        }
      })
      .catch(() => {
        // console.log(this.htmlEncodeLog(error));
        alert('Please try again later');
      });
  }

  redirectToPayBill(policyNumber: string, zipCode: string, minAmount: string) {
    this.billingPaymentService.makePayment(policyNumber, zipCode, minAmount);
  }

  // htmlEncodeLog(log: string): string {
  //   void log;
  //   return '${encoded}';
  // }

  private openInNewWindow(url: string) {
    if (this.urlValidationService.isApprovedRedirectUrl(url)) {

      const newWindow = window.open(url, '_blank');

      if (!newWindow) {
        alert('Please turn off the popup blocker');
      }
    }
  }
}
